<template>
    <div class="my-2 mx-3">
        <div class="cabecalho d-inline-flex">
            <div class="actions pt-2 pl-3">
                <az-title/>
            </div>
            <az-toolbar>
                <az-search slot="simpleSearch" @simple-search="buscaSimples" :filter="filtros"
                           @remove-filter="removerFiltro"
                           :simple-search-placeholder="placeholderPesquisa">
                </az-search>
            </az-toolbar>
        </div>
        <todas-compras-diretas-tabela class="listagem-compras" :itens="itens"
                                      :paginas="paginas"
                                      :total-itens="totalItens"
                                      :paginacao="paginacao"
                                      @paginar="paginar"
                                      @acessar="acessar" @baixarAta="baixarAta"/>
    </div>
</template>
<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {actionTypes} from '@/core/constants'
import TodasComprasDiretasTabela from './ComprasDiretasDisponiveisTabela'
export default {
    name: 'ConsultaDeComprasDiretas',
    mixins: [SmartTimerMixin],
    components: {TodasComprasDiretasTabela},
    data(){
        return{
            itens:[],
            paginas: 0,
            totalItens: 10,
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraPublicacao'
            },
            filtros: {
                situacoes: ['ABERTA', 'EM_ANALISE', 'REANALISE', 'ENCERRADA', 'SUSPENSA', 'AGUARDANDO_ABERTURA'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        }
    },
    computed: {
        placeholderPesquisa() {
            return 'Busque por: nº processo, nº consulta, objeto ou Órgão'
        }
    },
    methods:{
        async buscar() {
            const params = {
                filtros: this.filtros,
                paginacao: this.paginacao
            }
            const resultado = await this.$store.dispatch(actionTypes.BUSCAR_COMPRAS_DIRETAS_PUBLICAS, params)
            this.itens = resultado.compras
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements
        },
        async buscaSimples(valor){
            if(valor) {
                this.filtros.objeto.value = valor
                this.filtros.conteudo = valor
            }
            await this.buscar()
        },
        async baixarAta(id){
            await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_COMPRA_DIRETA, id)
        },
        acessar(compraDiretaId){
            this.$router.push({name: 'compraDiretaVisualizacaoDadosGerais', params: {id: compraDiretaId}})
        },
        paginar(paginacao) {
            this.paginacao = paginacao
            this.buscar()
        },
        removerFiltro(propriedade) {
            if (this.filtros && this.filtros.hasOwnProperty(propriedade)) {
                this.filtros[propriedade].value = this.filtros[propriedade].default
            }
            this.filtros.conteudo = ''
            this.buscar()
        },
        async atualizaDados(){
            await this.buscar()
        }
    },
    mounted() {
        this.createSmartTimer('atualizaDados', 'atualizaDados', 120000, {
            autostart: true,
            immediate: true
        })
    }
}
</script>
<style lang="stylus">
    .az-toolbar
        background-color transparent
        border none

    body
        background-color white
</style>
